// extracted by mini-css-extract-plugin
export default {"container":"_meRTi","section":"_hExT7","title":"_d6_Iv","body":"_Sw2Uq","cta":"_xtDJp"};